import React from 'react';
import { useInterval } from 'usehooks-ts';

import * as XLayout from '@pitaman71/react-explicit-layout';
import * as Debug from '../Debug';

export function AsWaiting(props: React.PropsWithChildren<{
    logo: JSX.Element
}>) {
    const children = Array.isArray(props.children) ? props.children : [props.children];
    return (
        <Debug.Boundary id='aswaiting' name="viewlogo-aswaiting">
            <XLayout.Stack.South style={{ minHeight: '0', maxHeight: '100%', maxWidth: '100%' }}>
                <XLayout.Center.Horizontal style={{ minHeight: '0', flex: '1' }}>
                    {props.logo}
                </XLayout.Center.Horizontal>
                <React.Fragment>
                    { children.map(child => {
                        return <XLayout.Center.Horizontal style={{ flex: '1', alignItems: 'center' }}>
                            {child}
                        </XLayout.Center.Horizontal>
                    })}
                </React.Fragment>
            </XLayout.Stack.South>
        </Debug.Boundary>
    );
}

export function AsSplash(props: React.PropsWithChildren<{
    logo: JSX.Element,
    duration: {
        attackMs: number,
        sustainMs: number,
        decayMs: number
    }
}>) {
    const [ sessionStart, ] = React.useState<Date>(new Date());
    const [ opacity, setOpacity ] = React.useState(1.0);
    useInterval(() => {
        const now = new Date();
        const delay = now.getTime() - sessionStart.getTime();
        if(delay < props.duration.attackMs) {
            setOpacity(delay / props.duration.attackMs);
        } else if(delay < (props.duration.attackMs + props.duration.sustainMs)) {
            if(opacity != 1.0)
                setOpacity(1.0);
        } else if(delay < (props.duration.attackMs + props.duration.sustainMs + props.duration.decayMs)) {
            setOpacity(1.0 - ((delay - props.duration.attackMs - props.duration.sustainMs)/props.duration.decayMs))
        } else {
            setOpacity(0);
        }
    }, opacity > 0.0 ? 100 : null);
    if(opacity == 0) {
        return (
            <React.Fragment>
                {props.children}
            </React.Fragment>
        );
    }
    return (
        <Debug.Boundary id='omniglot-mui-viewlogo-assplash' name="Omniglot.MaterialUi.ViewLogo.AsSplash">
            <XLayout.Fill>
                <XLayout.Center.Both>
                    <div style={{ opacity }}>            
                        {props.logo}
                    </div>
                </XLayout.Center.Both>
            </XLayout.Fill>
        </Debug.Boundary>
    );
}
